"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const randomstring_1 = __importDefault(require("randomstring"));
const log = debug_1.default('reduxRestHelper:rxdb');
const defaultCleanBody = (data) => {
    return data;
};
exports.RxDBCleanBody = defaultCleanBody;
exports.RxDBRequestCreator = (db, collectionName, cleanBody = defaultCleanBody) => ({
    // Get all records
    getAll: (filter) => {
        return new Promise((resolve, reject) => {
            db.then((db) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                log('LoopbackFilter', filter);
                let query = db[collectionName].find();
                if ((_a = filter) === null || _a === void 0 ? void 0 : _a.where) {
                    log('LoopbackFilter.where accepted', (_b = filter) === null || _b === void 0 ? void 0 : _b.where);
                    query = query.where(filter.where);
                }
                if ((_c = filter) === null || _c === void 0 ? void 0 : _c.order) {
                    const split = filter.order.split(' ');
                    log('LoopbackFilter.order & split accepted', (_d = filter) === null || _d === void 0 ? void 0 : _d.order, split);
                    query = query.sort({ [split[0]]: split[1] });
                }
                if (((_e = filter) === null || _e === void 0 ? void 0 : _e.limit) !== undefined) {
                    log('LoopbackFilter.limit accepted', (_f = filter) === null || _f === void 0 ? void 0 : _f.limit);
                    query = query.limit(filter.limit);
                }
                if (((_g = filter) === null || _g === void 0 ? void 0 : _g.skip) !== undefined) {
                    log('LoopbackFilter.skip accepted', (_h = filter) === null || _h === void 0 ? void 0 : _h.skip);
                    query = query.skip(filter.skip);
                }
                return query.exec();
            })
                .then((data) => {
                const json = data.map((d) => d.toJSON());
                log('Result', data);
                log('Result JSON', json);
                return resolve(json);
            })
                .catch(reject);
        });
    },
    // Count
    count: (filter) => {
        return new Promise((resolve, reject) => {
            db.then((db) => {
                var _a;
                let query;
                query = db[collectionName].find();
                if ((_a = filter) === null || _a === void 0 ? void 0 : _a.where) {
                    query.where(filter.where);
                }
                return query.exec();
            })
                .then((data) => {
                return resolve({ count: data.length });
            })
                .catch(reject);
        });
    },
    // Get record by id
    getById: (id, filter) => {
        return new Promise((resolve, reject) => {
            db.then((db) => db[collectionName].findOne().where({ id }).exec())
                .then((data) => {
                if (!data)
                    return reject(new Error('RX: Cannot find record'));
                return resolve(data.toJSON());
            })
                .catch(reject);
        });
    },
    // Delete record
    delete: (id) => new Promise((resolve, reject) => {
        db.then((db) => db[collectionName].findOne().where({ id }).exec())
            .then((record) => record.remove())
            .then(() => resolve({ id }))
            .catch(reject);
    }),
    // create record by id
    create: (body) => new Promise((resolve, reject) => {
        const bodyWithId = Object.assign(Object.assign({}, body), { id: randomstring_1.default.generate(), createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() });
        db.then((db) => db[collectionName].insert(bodyWithId))
            .then((data) => resolve(data.toJSON()))
            .catch(reject);
    }),
    // update record by id
    update: (id, body) => new Promise((resolve, reject) => {
        const updateBody = Object.assign(Object.assign({}, body), { updatedAt: new Date().toISOString() });
        delete updateBody.createdAt;
        db.then((db) => db[collectionName].findOne().where({ id }).exec())
            .then((record) => record.update({ $set: body }))
            .then((data) => resolve(data))
            .catch(reject);
    }),
});
//# sourceMappingURL=RxDBRequestCreator.js.map